import axios from 'axios';

// Set up base URL for all API requests
axios.defaults.baseURL = window.location.origin;

export const setupAxiosInterceptors = () => {
  // Add a request interceptor
  axios.interceptors.request.use(
    (config) => {
      // Get the token from localStorage
      const token = localStorage.getItem('token');
      
      // If token exists, add it to the headers
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;
